import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import LinearProgress from "@mui/material/LinearProgress";
import { CustomPagination, CustomNoRowsOverlay } from "../SecondaryFunctions";

const pageHeight = `calc(100vh - calc(11rem + 8px))`

// ];
const centerCell = (params) => (
	<div className="flex items-center justify-center h-full w-full text-center">
		{params.value}
	</div>
);

const columns = [
	{ field: "empid", headerName: "EMPID", flex: 0.7, minWidth: 70, align: "center", headerAlign: "center", renderCell: centerCell },
	{ field: "ccid", headerName: "CCID", flex: 0.8, minWidth: 75, align: "center", headerAlign: "center", renderCell: centerCell },
	{ field: "name", headerName: "NAME", flex: 1.2, minWidth: 110, align: "center", headerAlign: "center", renderCell: centerCell },
	{ field: "role", headerName: "ROLE", flex: 1.2, minWidth: 110, align: "center", headerAlign: "center", renderCell: centerCell },
	{ field: "dname", headerName: "DEPARTMENT", flex: 1.4, minWidth: 130, align: "center", headerAlign: "center", renderCell: centerCell },
	{ field: "fname", headerName: "FACULTY", flex: 2.4, minWidth: 180, align: "center", headerAlign: "center", renderCell: centerCell },
	{ field: "comment_redacting", headerName: "COMMENT REDACTING", flex: 0.9, minWidth: 105, align: "center", headerAlign: "center", renderCell: centerCell },
	{ field: "created_by", headerName: "CREATED BY", flex: 1.2, minWidth: 110, align: "center", headerAlign: "center", renderCell: centerCell },
	{ field: "created_on", headerName: "CREATED ON", flex: 1.2, minWidth: 110, align: "center", headerAlign: "center", renderCell: centerCell },
];


export default function ViewDDCs() {

    const [loaded,setLoaded] = useState(false)
    const [ddcData,SetDdcData] = useState([])
 
    useEffect(() => {
        const monthNames = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
        ];

        const url = process.env.REACT_APP_BACKEND_HOST;

        async function collect_ddc_table() {
            const response = await fetch(`${url}/spot/view_ddc_table/`, {
                headers: { Authorization: `Token ${sessionStorage.token}` },
            });

            const apiData = await response.json();

            const formatedData = apiData.map((row, index) => {
                const add_date = new Date(row.CREATION_DATE);
                const nameParts = row.NAME.split(",");
                const lastName = nameParts[0]?.trim() || "";
                const firstName = nameParts[1]?.trim() || "";
                return {
                    id: index,
                    empid: row.EMPID,
                    ccid: row.CCID,
                    name: `${firstName} ${lastName}`.trim(),
                    role: row.ROLE,
                    dname: row.DNAME,
                    fname: row.FNAME || "N/A",
                    comment_redacting: row.COMMENT_EDITING,
                    created_by: `${row.CREATED_BY}@ualberta.ca`,
                    created_on: `${monthNames[add_date.getMonth()]} ${add_date.getDate()}, ${add_date.getFullYear()}`,
                };
            });

            setTimeout(() => {
                SetDdcData(formatedData);
                setLoaded(true);
            }, 1000);
        
            
        }

        collect_ddc_table();
    }, []);

    return(
        
        <Box
            sx={{
                py: 2,
                px: 4,
                height: pageHeight,
                backgroundColor: "#f5f5f5",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <DataGrid
                // getRowHeight={() => "auto"}
                rowHeight={72}
                columns={columns}
                rows={ddcData}
                pageSize={100}
                rowsPerPageOptions={[100]}
                density={"compact"}
                loading={!loaded}
                slots={{
                    Pagination: CustomPagination,
                    LoadingOverlay: LinearProgress,
                    NoRowsOverlay: CustomNoRowsOverlay,
                }}
                
                sx={{
                    flex: 1,
                    width: "100%",

                    "& .MuiDataGrid-main": {
                        overflow: "hidden",
                    },

                    "& .MuiDataGrid-cell": {
                        whiteSpace: "normal",
                        lineHeight: "1.25rem",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        py: 0.5,
                    },

                    "& .MuiDataGrid-columnHeader": {
                        whiteSpace: "normal",
                    },

                    "& .MuiDataGrid-columnHeaderTitle": {
                        fontWeight: 700,
                        whiteSpace: "normal",
                        lineHeight: "1.1rem",
                        textAlign: "center",
                    },
                }}
            />
        </Box>
        
    )
}